//import { useState } from "react";
import HeaderSection from "../../components/HeaderSection";

const ContactUs = () => {
  const contacts = [
    {
      title: "CEO",
      name: "John Smith",
      phone: "+1 (555) 123-4567",
    },
    {
      title: "CTO",
      name: "Jane Doe",
      phone: "+1 (555) 234-5678",
    },
    {
      title: "HR Manager",
      name: "Mike Johnson",
      phone: "+1 (555) 345-6789",
    },
  ];

  return (
    <>
      <div className="main-content">
        <section className="section">
          <HeaderSection title="Contact Us" />
          <div className="card">
            <div className="card-header">
              <h4>Company Contacts</h4>
            </div>
            <div className="card-body">
              <div className="row">
                {contacts.map((contact, index) => (
                  <div key={index} className="col-12 col-md-4 col-lg-4">
                    <div className="card card-primary">
                      <div className="card-body">
                        <div className="d-flex justify-content-between">
                          <div>
                            <h6 className="text-muted">{contact.title}</h6>
                            <h6 className="font-weight-bold">{contact.name}</h6>
                            <p>{contact.phone}</p>
                          </div>
                          <div>
                            <a
                              href={`tel:${contact.phone}`}
                              className="btn btn-icon btn-primary">
                              <i className="fas fa-phone"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ContactUs;
